// extracted by mini-css-extract-plugin
export default {"moreButton":"CollectionList_moreButton__B0FiD","row":"CollectionList_row__RXYmT","name":"CollectionList_name__wYHra","pinned":"CollectionList_pinned__-4VZ0"};